import { Rating } from '@/models/Rating';
import Radio, { RadioProps } from '@mui/material/Radio';
import {
    FairIcon,
    FantasticIcon,
    GoodIcon,
    PoorIcon,
    VeryPoorIcon,
} from '../../icon';
import { RwdSvgIcon } from '@/components/common/rwdSvgIcon/RwdSvgIcon';
import { getVHByRem } from '@/utils/commonFunc';
type RatingIconProps = {
    r: number | Rating;
    checked?: boolean;
};
const RatingIcon = ({ r, checked = false }: RatingIconProps) => {
    const cn = checked ? 'checked' : 'un-checked';
    switch (r) {
        case Rating.VeryPoor:
            return <VeryPoorIcon className={cn} />;
        case Rating.Poor:
            return <PoorIcon className={cn} />;
        case Rating.Fair:
            return <FairIcon className={cn} />;
        case Rating.Good:
            return <GoodIcon className={cn} />;
        case Rating.Fantastic:
            return <FantasticIcon className={cn} />;
        default:
            return <></>;
    }
};
type RatingRadioProps = RadioProps;
export const RatingRadio = (props: RatingRadioProps) => {
    const { value } = props;
    return (
        <Radio
            disableRipple
            color="default"
            checkedIcon={
                <RwdSvgIcon vSize={2} hSize={getVHByRem(2)}>
                    <RatingIcon r={value as Rating} checked />
                </RwdSvgIcon>
            }
            icon={
                <RwdSvgIcon vSize={2} hSize={getVHByRem(2)}>
                    <RatingIcon r={value as Rating} />
                </RwdSvgIcon>
            }
            {...props}
        />
    );
};
